/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { EomReportDto, EomReportMethod, EomReportRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { ID, ProduceStatus } from '@gh/common-shared-data';
import { map$, mergeMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { EomReport } from './eom-report.model';
import { PrinterBusinessService } from '@gh/builder-shared';
import { combineLatest$, of$ } from '@gh/rx';

@Injectable()
export class EomReportBusinessService implements InitViewService {
  constructor(
    private dictionaries: DictionaryService,
    private eomRest: EomReportRestService,
    private printers: PrinterBusinessService,
  ) {
  }

  initView(): any {
    return {
      eomMethodDict: this.dictionaries.getByEnum(EomReportMethod),
      eomReport: this.get(),
      printData: this.printers.getPrinters(),
    };
  }

  get(): Observable<EomReport | EomReportDto> {
    const id = localStorage.getItem('eomTaskId');
    if (id) {
      return combineLatest$([this.eomRest.get(), this.eomRest.getProduceStatus(id)]).pipe(
        map$(([eom, produceStatus]) => ({ ...eom, produceStatus })));
    } else {
      return this.eomRest.get();
    }
  }

  save(report: EomReport): Observable<ProduceStatus> {
    const dto = {...report};
// @ts-expect-error Legacy typing suppression
    delete dto.produceStatus;
    return this.eomRest.save(this._clearWhsDetailsForNoWhs(dto)).pipe(map$((resp) => {
      localStorage.setItem('eomTaskId', resp.eomTaskId);
      return resp.eomTaskId;
    }),                                                               mergeMap$((value) =>
        this.eomRest.getProduceStatus(value)));
  }

  validate(forYear: number, forMonth: number): Observable<any> {
    return this.eomRest.validate(forYear, forMonth);
  }

  getProduceStatus(id: ID): Observable<ProduceStatus> {
    if (!id) {
      return of$({
        total: 0,
        processed: 0,
      });
    } else {
      return this.eomRest.getProduceStatus(id);
    }
  }

  gets3Link(id: ID): Observable<any> {
    return this.eomRest.getS3Link(id);
  }

  private _clearWhsDetailsForNoWhs(report: EomReport): EomReport {
    if (!report.whs) {
      report.whsDetails = '';
    }
    report.historyEomSettings.forEach((item) => {
      if (!item.whs) {
        item.whsDetails = '';
      }
    });
    return report;
  }
}
